import React, { useState } from "react";
import CTooltip from "react-tooltip-lite";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { Bar } from "react-chartjs-2";
import { shuffle } from "lodash";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
import ErrorBoundary from "components/ErrorBoundary";
import DownloadCSVButton from "./DownloadCsv";
// import Download from "../../../../assets/icon/Download - Icon 3.svg";
// import DownloadCSVButton from "pages/Dashboard/DownlaodCSV";

const WholesalerSpend = (props) => {
  const {selectsearch}=props

    const data=[
        {
            "id": 5432156789,
            "name": "FFF",
            "count": 4,
            "value": 1139.88,
            "labelToolTip": "5432156789",
            "display": "$1,139.88"
        },
        {
            "id": 4578520010,
            "name": "DakotaDrug",
            "count": 3,
            "value": 567.78,
            "labelToolTip": "4578520010",
            "display": "$567.78"
        },
        {
            "id": 1346249109,
            "name": "Morris and Dickson",
            "count": 1,
            "value": 296.74,
            "labelToolTip": "1346249109",
            "display": "$296.74"
        },
        {
            "id": 1920217161,
            "name": "Cardinal Health",
            "count": 249,
            "value": -218011.557,
            "labelToolTip": "1920217161",
            "display": "$-218,011.56"
        },
        {
            "id": 5487634876,
            "name": "Mckesson Pharmaceuticals",
            "count": 20,
            "value": -227040.09,
            "labelToolTip": "5487634876",
            "display": "$-227,040.09"
        },
        {
            "id": 5487634876,
            "name": "ELETRIPTAN HBR 40 MG TABLET",
            "count": 20,
            "value": -227040.09,
            "labelToolTip": "5487634876",
            "display": "$-227,040.09"
        }
    ]
  const [active, setActive] = useState("6");
  const names = [];
  const ammountcount = [];

//   let maxValue = Math.max.apply(
//     null,
//     data.map(function (o) {
//       return o.value;
//     })
//   );
//   data.forEach(({ name, display }) => {
//     names.push(name);
//     ammountcount.push(display.replace(/[^0-9.-]+/g, ""));
//   });
  // (ammountcount, "amountcount");

  const chartData = {
    labels: ["FFF","DakotaDrug","Morris and Dickson","Cardinal Health","Mckesson Pharmaceuticals",],
    datasets: selectsearch==true?[
      {
        label: "340B Savings",
        data: [162,145,126,100,80],
        borderColor: "#702c62",
        backgroundColor: "#702c62",
      },
    ]:[],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    // maintainAspectRatio: true,
    indexAxis: "y",
    scales: {
      x: {
        ticks: {
          color: "#212121",
          callback: function (value, index, ticks) {
            return "$" + value  + "k";
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          color: "#212121",
        },
        grid: {
          display: false,
        },
      },
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          // title: function (item) {
          //   const { name, count } = data[item[0].dataIndex];
          //   return `${name}\nTotal Claim Count : ${count}`;
          // },
          label: function (d, t) {
            var xLabel = d.dataset.label;
            var yLabel =
              "$" +
              Number(d.formattedValue.replace(/[^0-9.-]+/g, ""))
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            return xLabel + ": " + yLabel;
          },
        },
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
        align: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? "end"
            : "start";
        },
        color: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? "black"
            : "black";
        },
        anchor: function (context) {
          return context.dataset.data[context.dataIndex] < maxValue / 2
            ? "end"
            : "center";
        },
        padding: {
          right: 2,
        },
        labels: {
          padding: { top: 10 },
          value: {
            color: "#2B3346",
          },
        },
        formatter: function (value) {
          return (
            "$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
          );
        },
      },
    },
  };

  const handleActive = (title) => {
    if (active === title) return;
    const shuffleArry = shuffle(data);
    setActive(title);
    setData(shuffleArry);
  };

  const getDate = () => {
    setActive("custom");
  };

  return (
    <ErrorBoundary>
      <Card className="p-3 h-100 shadow-top">
        <CardHeader className="border-0 bg-white px-0">
          <Row className="align-items-center">
            <Col>
              {/* <CTooltip
                content={
                  <div className="tip-list-info" style={{ width: "300px" }}>
                    <p>
                      Top 10 performing pharmaices based on replenished 340B Savings.
                      340B Savings = Total Paid-Dispense Fee- Est.340B Drug Cost
                    </p>
                  </div>
                }
              > */}
                <CardTitle className="f-20 font-weight-600 dashboard-headings">
                  <div className="d-flex justify-content-between align-items-center top_left_hed pb-1 graph-headings">
                Spend by Wholesalers
                    <DownloadCSVButton
monthsdata={[]}
valuedata1={[]}
valuedata2={[]}
                      // valuedata2={ces}
                      heading1={["Pharmacy Names", "Amount"]}
                      filenamedata={"Top_10_Pharmacies"}
                      download={false}

                    />
                    {/* <img src={Download} /> */}
                  </div>
                </CardTitle>
              {/* </CTooltip> */}
            </Col>
            <Col xs="auto">
              <Nav className="widget-tabs"></Nav>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className="dashboard-chart-body p-0">
          <div className="dashboard-chart-height chat-container">
            <Bar
              options={options}
              data={chartData}
              plugins={[ChartDataLabels]}
            />
          </div>
        </CardBody>
      </Card>
    </ErrorBoundary>
  );
};

export default WholesalerSpend;
